import React, { useState, useCallback } from 'react';
import { useBranding } from '@src/theme/branding/useBranding';
import { ASSET_TYPE } from '../react-three-components/sceneAsset';
import ModelViewerModal from '@src/components/side-bar-menu/web2-asset-store/ModelViewer';
import styles from '../add-to-scene.module.css';

export default function ThreeDLibraryContent({
  onAddToScene,
  buildScene,
  session,
  selectedSceneTemplate,
}) {
  const { isZepeto } = useBranding();
  const [previewOpen, setPreviewOpen] = useState<boolean>(false);
  const [modelUrl, setModelUrl] = useState<string>('');

  const onLoadAsset = (element) => {
    let assetType = ASSET_TYPE.GLTF.OTHER;

    onAddToScene({
      type: assetType,
      name: element.name || `Asset-${Date.now()}`,
      url: element.url || element.thumbnail,
      previewImage: element.thumbnail,
    });
  };

  const onOpenPreview = useCallback((url) => {
    setPreviewOpen(true);
    setModelUrl(url);
  }, []);

  const handleImageClick = (element, event) => {
    event.stopPropagation();
    if (element.url) {
      onOpenPreview(element.url);
    }
  };

  if (!buildScene) {
    return (
      <div className={styles.contentWrapper}>
        <div className={styles.emptyContent}>No 3D library items available</div>
      </div>
    );
  }

  const items = buildScene.items || buildScene;

  if (isZepeto) {
    const zepetoItems = items['Pack2'] || [];

    return (
      <div className={styles.contentWrapper}>
        <div className={styles.topSection}>
          <h3 className={styles.sectionTitle}>3D Library</h3>
        </div>

        <div className={styles.gridContainer}>
          {zepetoItems.map((element, index) => {
            const canPreview = element.url;

            return (
              <div
                key={element.id || `zepeto-${index}`}
                className={styles.libraryItem}
                onClick={() => onLoadAsset(element)}
              >
                <img
                  src={element.thumbnail}
                  alt={element.name || `Asset ${index}`}
                  className={styles.libraryThumbnail}
                  onClick={(e) => handleImageClick(element, e)}
                  style={{ cursor: element.url ? 'pointer' : 'default' }}
                />

                {canPreview && (
                  <div
                    className={styles.previewIcon}
                    onClick={(e) => {
                      e.stopPropagation();
                      onOpenPreview(element.url);
                    }}
                    title='Preview'
                  >
                    👁
                  </div>
                )}

                <div className={styles.libraryItemName}>
                  {element.name || `Asset ${index}`}
                </div>

                <button
                  className={styles.addToSceneButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    onLoadAsset(element);
                  }}
                >
                  Add to scene
                </button>
              </div>
            );
          })}
        </div>

        <ModelViewerModal
          open={previewOpen}
          setOpen={setPreviewOpen}
          modelUrl={modelUrl}
        />
      </div>
    );
  }

  const pack1Items = items['Pack1'] || [];

  if (pack1Items.length === 0) {
    return (
      <div className={styles.contentWrapper}>
        <div className={styles.emptyContent}>No Pack1 items available</div>
      </div>
    );
  }

  return (
    <div className={styles.contentWrapper}>
      <div className={styles.topSection}>
        <h3 className={styles.sectionTitle}>3D Library</h3>
      </div>

      <div className={styles.gridContainer}>
        {pack1Items.map((element, itemIndex) => {
          const canPreview = element.url;

          return (
            <div
              key={element.id || `pack1-${itemIndex}`}
              className={styles.libraryItem}
              onClick={() => onLoadAsset(element)}
            >
              <img
                src={element.thumbnail}
                alt={element.name || `Asset ${itemIndex}`}
                className={styles.libraryThumbnail}
                onClick={(e) => handleImageClick(element, e)}
                style={{ cursor: element.url ? 'pointer' : 'default' }}
              />

              {canPreview && (
                <div
                  className={styles.previewIcon}
                  onClick={(e) => {
                    e.stopPropagation();
                    onOpenPreview(element.url);
                  }}
                  title='Preview'
                >
                  👁
                </div>
              )}

              <div className={styles.libraryItemName}>
                {element.name || `Asset ${itemIndex}`}
              </div>

              <button
                className={styles.addToSceneButton}
                onClick={(e) => {
                  e.stopPropagation();
                  onLoadAsset(element);
                }}
              >
                Add to scene
              </button>
            </div>
          );
        })}
      </div>

      <ModelViewerModal
        open={previewOpen}
        setOpen={setPreviewOpen}
        modelUrl={modelUrl}
      />
    </div>
  );
}
